export const intercomStorageAdapter = {
  setToken: (token: string) => {
    if (typeof window !== 'undefined') {
      localStorage.setItem('intercomToken', token)
    }
  },
  getToken: (): string | null => {
    if (typeof window !== 'undefined') {
      return localStorage.getItem('intercomToken')
    }
    return null
  },
  clearToken: () => {
    if (typeof window !== 'undefined') {
      localStorage.removeItem('intercomToken')
    }
  },
}
